import * as ACTION_TYPES from './types';

export function toggleSidebar() {
  return {
    type: ACTION_TYPES.UI_TOGGLE_SIDEBAR,
  };
}

export function toggleSettings(available) {
  return {
    type: ACTION_TYPES.UI_TOGGLE_SETTINGS,
    payload: {
      available,
    },
  };
}

export function setOpenPool(status) {
  return {
    type: ACTION_TYPES.UI_SET_OPEN_POOL,
    payload: {
      status,
    },
  };
}

export function setOffline(offline) {
  return {
    type: ACTION_TYPES.UI_SET_OFFLINE,
    payload: { offline },
  };
}

export function setToastPosition(toastPosition) {
  return {
    type: ACTION_TYPES.UI_SET_TOAST_POSITION,
    payload: { toastPosition },
  };
}

export function clearToast() {
  return {
    type: ACTION_TYPES.UI_CLEAR_TOAST,
  };
}
export function showToast(toast) {
  return {
    type: ACTION_TYPES.UI_SHOW_TOAST,
    payload: toast,
  };
}

export function toggleAINoteModal(payload) {
  return {
    type: ACTION_TYPES.UI_TOGGLE_AI_NOTE_MODAL,
    payload,
  };
}

export function updateShowAiCheckerTooltip(payload) {
  return {
    type: ACTION_TYPES.UI_SHOW_AI_CHECKER_TOOLTIP,
    payload,
  };
}
